<template>
	<div class="page">
		<div class="page-header flex justify-content-space-around align-items">
			<img :src="$path+pageDetail.icon" alt="" class="page-header-img" />
			<div class="page-header-info page-width flex-column justify-content-center">
				<div>
					<span class="page-chName">{{pageDetail.name}}</span>
					<span class="page-esName">{{pageDetail.enName}}</span>
				</div>
				<div class="page-bg-text">
					{{pageDetail.description}}
				</div>
			</div>
		</div>
		<div class="container pageCont">
			<div class="row">
				<div class="col-lg-3 leftMenu text-center">
					<div class="leftMenu-title flex">
						<img src="@/assets/abouticon.png" alt="" style="width: 30px; height: 30px; margin-right: 5px" />
						<div class="flex-column text-left">
							<h3 style="font-size: 25px; color: #333333; margin-bottom: 0 !important">
								关于奉航
							</h3>
							<p style="font-size: 14px; color: #dbdbdb">ABOUT US</p>
						</div>
					</div>
					<div class="apiLeftMenu text-center" style="padding-top: 25px; padding-bottom: 25px; background: #f6f6f6">
						<div class="apiLeftMenu-ever flex justify-content-space-around align-items" @click="menuChange(item)" v-for="(item, i) in menulist"
						 :key="i" :style="changeStatus == item.id ? 'background:#FFFFFF;color:#0090FF;' : ''">
							<span>{{ item.name }}</span>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
				</div>
				<div class="col-lg-9 col-md-12 col-sm-12 col-12 rightCont">
					<!--头部-->
					<div class="rightCont-title">
						<span>当前位置：</span>
						<span class="page-click" @click="tohome">首页</span>
						<i class="el-icon-arrow-right"></i>
						<span class="page-click" @click="torefresh">关于奉航</span>
						<i class="el-icon-arrow-right"></i>
						<span class="page-click">{{ pageName }}</span>
					</div>
					<div class="rightCont-menu-box">
						<div class="rightCont-menu flex align-items justify-content-space-between" @click="showMenu">
							<div class="flex align-items">
								<img src="@/assets/abouticon.png" alt="" style="width:20px;height:20px;margin-left:15px;">
								<div style="font-size:18px;color:#333333;margin-left:5px;">关于奉航</div>
								<span style="color:#DBDBDB;font-size:14px;margin-left:10px;padding-top:5px;">{{pageDetail.enName}}</span>
							</div>
							<van-icon name="plus" color="#666666" style="margin-right:15px;" />
							<transition name="el-zoom-in-top">
								<div class="click-show" v-if="mobMenustatus">
									<van-cell-group>
										<van-cell :title="item.name" :style="changeStatus == item.id?'color:red;':''" v-for="(item, i) in menulist"
										 @click="menuChange(item)" :key="i">
											<!-- 使用 right-icon 插槽来自定义右侧图标 -->
											<template #right-icon v-if="changeStatus == item.id">
												<van-icon name="success" color="red" size="20px" />
											</template>
										</van-cell>
									</van-cell-group>
								</div>
							</transition>
						</div>
					</div>
					<div class="rightCont-html" v-if="changeStatus != '10207'&&changeStatus!='10208'" v-html="detail.comment"></div>
					<!-- 招聘 -->
					<div class="rightCont-collapse" v-if="changeStatus == '10207'">
						<div class="rightCont-collapse-ever page-click" @click="showCollapse(i)" v-for="(item, i) in list" :key="i"
						 :style="clickStatus == i ? 'border: 1px solid #ff6700 !important;' : ''">
							<div class="rightCont-collapse-ever-title flex justify-content-space-between align-items">
								<span style="font-size: 18px; color: #333333">{{ item.title }}/{{ item.num }}人</span>
								<i :class="clickStatus == i ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
							</div>
							<div style="padding-bottom:20px;" v-if="clickStatus == i">
								<div class="noneClick">岗位要求：{{item.content}}</div>
								<div class="noneClick">计件工资：{{item.treatment}}</div>
								<div class="noneClick">公司福利：{{item.welfare}}</div>
								<div class="noneClick">公司地址：{{item.address}}</div>
								<div class="noneClick">联系方式：{{item.phone}}</div>
								<div class="noneClick">简历投递：{{item.email}}</div>
								<div class="noneClick">面试时间：{{item.time}}</div>
							</div>
						</div>
					</div>
					<!-- 地图 -->
					<div v-if="changeStatus == '10208'">
						<div class="map" style="margin-top:30px;">
							<div id="allmap" class="allmap" style="width: 100%; height:300px;margin-bottom:50px;margin-top:50px;"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		MP
	} from "@/map.js";
	export default {
		data() {
			return {
				menulist: [],
				list: [],
				detail: {},
				changeStatus: "",
				pageName: "",
				clickStatus: 10086,
				mobMenustatus: false,
				pageDetail: {},
			};
		},
		mounted() {
			this.getmap();
		},
		created() {
			if (window.localStorage.getItem("changeStatus") != null) {
				this.changeStatus = window.localStorage.getItem("changeStatus");
			}
			this.getleftMenu();
			this.getPage();
		},
		methods: {
			getPage() {
				this.$api.iotHome.levelNavigation({
					columnId: "102"
				}).then(res => {
					if (res.success) {
						this.pageDetail = res.data;
					}
				})
			},
			tohome() {
				this.$router.replace({
					path: "/"
				})
			},
			torefresh() {
				window.localStorage.removeItem('changeStatus');
				this.$router.push({
					path: "/back",
					query: {
						path: this.$route.path
					}
				})
			},
			getleftMenu() {
				this.$api.iotHome
					.getList({
						columnId: "102",
					})
					.then((res) => {
						if (res.success == true) {
							this.menulist = res.data;
							if (this.changeStatus == "") {
								this.changeStatus = this.menulist[0].id;
							}
							for (let i = 0; i < this.menulist.length; i++) {
								if (this.changeStatus == this.menulist[i].id) {
									this.pageName = this.menulist[i].name;
								}
							}
							this.getdetail(this.changeStatus);
							this.getmap();
						}
					});
			},
			getmap() {
				this.$nextTick(function() {
					var ak = 'aXeV2twYjcxgPqzusUyDYlV75Mqd2odB';
					MP(ak).then(BMap => {
						var map = new BMap.Map("allmap"); // 创建Map实例
						map.centerAndZoom(new BMap.Point(108.442142, 34.310273), 15); // 初始化地图,设置中心点坐标和地图级别
						map.addControl(new BMap.MapTypeControl()); //添加地图类型控件
						map.setCurrentCity("咸阳市"); // 设置地图显示的城市 此项是必须设置的
						map.addControl(new BMap.MapTypeControl({
							mapTypes: [
								'BMAP_NORMAL_MAP',
								'BMAP_HYBRID_MAP'
							]
						}));
						map.enableScrollWheelZoom(true);
						// var opts = {
						// 	width: 280, // 信息窗口宽度    
						// 	height: 75, // 信息窗口高度    
						// 	title: "陕西博凯迪克机电技术检测有限公司" // 信息窗口标题   
						// }
						var marker = new BMap.Marker(new BMap.Point(108.442142, 34.310273));
						map.addOverlay(marker);
						// var infoWindow = new BMap.InfoWindow("地址：陕西省榆林市定边县陕西省榆林市定边县定边镇北环路义友汽修东旁", opts); // 创建信息窗口对象    
						map.openInfoWindow(infoWindow, map.getCenter());
						marker.addEventListener("click", function() {
							map.openInfoWindow(infoWindow, map.getCenter()); //打开信息窗口  
						});
					})
				})
			},
			getdetail(id) {
				this.$api.iotHome.aboutFhDetails({
					cmsColumnId: id
				}).then((res) => {
					if (res.success == true) {
						if (id != "10207") {
							this.detail = res.data;
							this.detail.comment = this.detail.comment.replace(
								/src="(?![http])/g,
								'src="' + this.$paths
							);
						} else {
							this.list = res.data;
						}
					}
				});
			},
			showCollapse(index) {
				if (this.clickStatus == 10086) {
					this.clickStatus = index;
				} else {
					if (this.clickStatus != index) {
						this.clickStatus = index;
					} else {
						this.clickStatus = 10086;
					}
				}
			},
			showMenu() {
				this.mobMenustatus = !this.mobMenustatus;
			},
			menuChange(data) {
				this.changeStatus = data.id;
				this.pageName = data.name;
				window.localStorage.setItem("changeStatus", data.id);
				this.getdetail(data.id);
				this.getmap();
			},
		},
	};
</script>

<style>
	@import url("../style/page.css");
</style>
<style scoped>
	.rightCont-html /deep/ img {
		max-width: 100%;
		height: auto !important;
	}

	.rightCont-html /deep/ table {
		max-width: 100%;
		width: auto;
		height: auto;
	}

	.rightCont-html /deep/ p {
		line-height: 35px !important;
	}

	.click-show /deep/ .van-cell {
		border-bottom: 0.5px solid #DBDBDB !important;
	}
</style>
